import { createSlice } from '@reduxjs/toolkit';
import { getJobListThunk, getJobTypesListThunk } from './Job.thunk';

export const jobSlice = createSlice({
  name: 'job',
  initialState: {
    list: {
      items: [],
      loading: true,
      pagination: {},
    },
    types: {
      items: [],
      loading: true,
    },
  },
  reducers: {
    resetJobsListAction: (state, action) => ({
      ...state,
      list: {
        ...state.list,
        items: [],
        pagination: {},
      },
    }),
    resetJobTypesListAction: (state, action) => ({
      ...state,
      types: {
        ...state.types,
        items: [],
      },
    }),
  },
  extraReducers: builder => {
    // Start job list
    builder.addCase(getJobListThunk.pending, (state, action) => ({
      ...state,
      list: { ...state.list, loading: true },
    }));
    builder.addCase(getJobListThunk.fulfilled, (state, action) => {
      const { data, pagination: _pagination } = action.payload;
      const pagination = {
        currentPage: _pagination.current_page,
        lastPage: _pagination.last_page,
        total: _pagination.total,
      };
      state.list = { ...state.list, items: data, pagination, loading: false };
    });
    builder.addCase(getJobListThunk.rejected, (state, action) => {
      // state.list = { ...state.list, loading: false };
    });
    // End job list
    // Start job types list
    builder.addCase(getJobTypesListThunk.pending, (state, action) => ({
      ...state,
      types: { ...state.types, loading: true },
    }));
    builder.addCase(getJobTypesListThunk.fulfilled, (state, action) => {
      const { data } = action.payload;
      state.types = { ...state.types, items: data, loading: false };
    });
    builder.addCase(getJobTypesListThunk.rejected, (state, action) => {
      // state.types = { ...state.types, loading: false };
    });
    // End job types list
  },
});

export const { resetJobsListAction } = jobSlice.actions;
export const getJobsList = (state: any) => state.job.list;

export default jobSlice.reducer;
